import type { IContactDetailsFilterDto } from "app/pages/sales-intelligence/domain/contacts/types/filter-values";
import { ContactDetail } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/enums";

export const CONTACT_PAIRS: ReadonlyArray<[keyof IContactDetailsFilterDto, ContactDetail]> = [
    ["hasEmail", ContactDetail.Email],
    ["hasMobilePhone", ContactDetail.MobilePhone],
    ["hasDirectPhone", ContactDetail.DirectPhone],
    ["hasEmailAndMobilePhone", ContactDetail.EmailAndMobilePhone],
];
